import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';

import {AnalysisGraphQL, GetAnalysisPipelineStep} from './AnalysisTypes';

export function isStepInProgress(step: GetAnalysisPipelineStep): boolean {
  return (
    step.statusCode === PipelineStepStatusCode.AI_PROPOSED ||
    step.statusCode === PipelineStepStatusCode.BLOCKED ||
    step.statusCode === PipelineStepStatusCode.RUNNING ||
    step.statusCode === PipelineStepStatusCode.WAITING
  );
}

/** Return whether or not the analysis has any RUNNING pipeline steps */
export default function isAnalysisRunning(analysis: Pick<AnalysisGraphQL, 'execution'>): boolean {
  return analysis.execution.steps.some(
    (step) =>
      step.statusCode === PipelineStepStatusCode.RUNNING || step.statusCode === PipelineStepStatusCode.BLOCKED
  );
}
